import { render } from "./MessageDialog.vue?vue&type=template&id=394fb54c&scoped=true"
import script from "./MessageDialog.vue?vue&type=script&lang=ts"
export * from "./MessageDialog.vue?vue&type=script&lang=ts"

import "./MessageDialog.vue?vue&type=style&index=0&id=394fb54c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-394fb54c"
/* hot reload */
if (module.hot) {
  script.__hmrId = "394fb54c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('394fb54c', script)) {
    api.reload('394fb54c', script)
  }
  
  module.hot.accept("./MessageDialog.vue?vue&type=template&id=394fb54c&scoped=true", () => {
    api.rerender('394fb54c', render)
  })

}

script.__file = "src/components/common/dialog/MessageDialog.vue"

export default script